// extracted by mini-css-extract-plugin
var _1 = "LabeledGraphicElement_close__ccd76";
var _2 = "LabeledGraphicElement_demo__c93cd";
var _3 = "LabeledGraphicElement_navigation__e2576";
var _4 = "LabeledGraphicElement_readonly__bc89c";
var _5 = "LabeledGraphicElement_root__73a18";
var _6 = "LabeledGraphicElement_slider__09fc7";
var _7 = "LabeledGraphicElement_tooltip__c3142";
export { _1 as "close", _2 as "demo", _3 as "navigation", _4 as "readonly", _5 as "root", _6 as "slider", _7 as "tooltip" }
